import { CascadiaSpacing } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useContext } from "react";

import { AccordionContext } from "./Accordion";

export interface AccordionPanelProps {
  children: React.ReactNode;
  paddingLeft?: CascadiaSpacing;
  paddingRight?: CascadiaSpacing;
  inlinePanel?: boolean;
}

export function AccordionPanel(props: AccordionPanelProps) {
  const { paddingLeft = "space-6", paddingRight = "space-6" } = props;
  const { isOpen } = useContext(AccordionContext);

  return (
    <div className={styles.wrapper}>
      <div className={css({ width: "100%" })}>
        {/* ^ extra div required for 100% max-height animation */}
        <div
          data-open={isOpen}
          aria-hidden={isOpen}
          className={css(
            props.inlinePanel ? styles.inlinePanel : styles.panel,
            {
              paddingLeft: `var(--${paddingLeft})`,
              paddingRight: `var(--${paddingRight})`,
            }
          )}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: css({ display: "flex" }),
  panel: css({
    "&[data-open=false]": {
      maxHeight: "0",
      opacity: "0",
    },
    "&[data-open=true]": {
      maxHeight: "100%",
      opacity: "1",
    },
    overflow: "hidden",
    transition: "all 0.2s ease-out",
  }),
  inlinePanel: css({
    "&[data-open=true]": {
      maxHeight: "100%",
      opacity: "1",
    },
    overflow: "hidden",
    transition: "all 0.2s ease-out",
  }),
};
